// extracted by mini-css-extract-plugin
export default {"productDescription":"lea-z","featuredDescription":"mea-z","description":"nea-z","more":"oea-z","descriptionSku":"pea-z"};